import { useState, useEffect } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";

// Scan button in Scanning.jsx:
// bottom: 30px, height: 8rem (128px)
// So button top edge = 30 + 128 = 158px from bottom
const DASHED_LINE_HEIGHT = 60;
const BUBBLE_PADDING = 20; // breathing room between bubble bottom and line top
const TOOLTIP_BOTTOM = 158 + DASHED_LINE_HEIGHT + BUBBLE_PADDING; // ~238px from bottom

export const ScannerTooltipView = ({ onOpen, onClose, forceClose, disabled }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (forceClose) {
      setIsVisible(false)
    }
  }, [forceClose])

  const handleToggle = () => {
    if (!isVisible) {
      onOpen?.()
    } else {
      onClose?.()
    }
    setIsVisible((prev) => !prev)
  };

  return (
    <>
      {/* Dark overlay - non-interactive so scan button still works beneath */}
      {isVisible && (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.7)",
            zIndex: 1050,
            pointerEvents: "none",
          }}
        />
      )}

      {/* Info / Close button - top left */}
      <Box
        sx={{
          position: "fixed",
          top: 12,
          left: 12,
          zIndex: 1200,
        }}
      >
        <IconButton
          onClick={handleToggle}
          disabled={disabled}
          sx={{
            width: 50,
            height: 50,
            backgroundColor: "transparent",
            color: "white",
            opacity: disabled ? 0.4 : 1,
            transition: "opacity 0.3s ease",
            "&.Mui-disabled": {
              color: "white",
              backgroundColor: "transparent",
            },
            "&:hover": {
              backgroundColor: "transparent",
            },
            "&:active": {
              backgroundColor: "transparent",
            },
          }}
        >
          {isVisible
            ? <CloseIcon fontSize="large" />
            : <InfoOutlinedIcon fontSize="large" />
          }
        </IconButton>
      </Box>

      {/* Tooltip bubble + dashed line */}
      {isVisible && (
        <Box
          sx={{
            position: "fixed",
            bottom: `${TOOLTIP_BOTTOM}px`,
            left: 0,
            right: 0,
            zIndex: 1200,
            px: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box sx={{ position: "relative", display: "flex", justifyContent: "center" }}>
            {/* Text bubble */}
            <Typography
              sx={{
                color: "yellow",
                fontWeight: "bold",
                textAlign: "center",
                border: "2px solid yellow",
                borderRadius: 2,
                p: 2,
                maxWidth: 280,
              }}
            >
              Point camera at image and tap the scan button
            </Typography>

            {/* Dashed line pointing down to center of scan button */}
            <Box
              sx={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                height: `${DASHED_LINE_HEIGHT}px`,
                borderLeft: "2px dashed yellow",
              }}
            />
          </Box>
        </Box>
      )}
    </>
  );
};